import {
    all,
    takeEvery,
    put
} from "redux-saga/effects";
import ApiService from "../../Services/ApiService";
import {
    FETCH_REPORT, 
    CUSTOM_REPORT_FETCH_CHART,
    CUSTOM_REPORT_CREATE_BOT,
    FETCH_JOURNEY_REPORT_METADATA
} from "../constants/dashboard";
import { 
    saveReport, 
    customReportSaveBotStatus, 
    customReportSaveBotCharts, 
    customReportFetchChart,
    saveJourneyReportMetadata
} from "../actions/dashboard";

import { toastNotification } from "../../utils/toastNotification";

function* fetchReports() {
    yield takeEvery(FETCH_REPORT, function* (action) {
        
        try {
            const res = yield ApiService.get(
                `/hulk/api/v1/report/${action.payload.type}/${action.payload.subtype}`, {}, action.payload.query
            );
            // debugger;
            if (res.status == "success") {
                if (!(res.data instanceof Array)) {
                    res.data = [res.data]
                }
                yield put(saveReport(action.payload.type, action.payload.subtype, res.data));
                // debugger;
                if (action.payload.callback) {
                    action.payload.callback();
                }
            }
        } catch (error) {
            console.log(error)
            // yield put();
        }
    });
}

function* fetchCustomReportBotSaga() {
    yield takeEvery(CUSTOM_REPORT_FETCH_CHART, function* (action) {
        try {
            const res = yield ApiService.get("/strange/report_chart");

            if (res.status == "success") {
                yield put(customReportSaveBotStatus(res.data.status));
                console.log(res.data.data);
                yield put(customReportSaveBotCharts(res.data.data || []));
            } else {
                yield put(customReportSaveBotStatus(res.status));
            }
        } catch (error) {
            // toastNotification({errorMessage: "Unable to fetch reports"});
            console.log(error)
        }
    });
}

function* fetchJourneyReportMetadataSaga() {
    yield takeEvery(FETCH_JOURNEY_REPORT_METADATA, function* (action) {
        try {
            const res = yield ApiService.get("/hulk/api/v1/custom-reports");

            if (res.status == "success") {
                yield put(saveJourneyReportMetadata(res.data));
            } else {
                toastNotification({ res });    
            }
        } catch (error) {
            toastNotification({errorMessage: "Unable to fetch journey reports"});
            console.log(error)
        }
    });
}

function* createCustomReportBotSaga() {
    yield takeEvery(CUSTOM_REPORT_CREATE_BOT, function* (action) {
        try {
            const res = yield ApiService.post("/strange/report_bot");
            toastNotification({res});
            if (res.status == "success") {
                yield put(customReportFetchChart());
            }
        } catch (error) {
            toastNotification({errorMessage: "Unable to initialize custom report dashboard"});
        }
    });
}

export default function* rootSaga() {
    yield all([
        fetchReports(),
        fetchCustomReportBotSaga(),
        createCustomReportBotSaga(),
        fetchJourneyReportMetadataSaga()
    ]);
}
